import { Injectable } from "@angular/core";
import { JQueryHTTPClient } from "../rest/JQueryHTTPClient";
import { EntityService } from "../rest/entity.service";
import { Rest } from "../rest/rest_client";

@Injectable()
export class SubdelegationService extends EntityService<Rest.Subdelegation> {
  client: Rest.RestApplicationClient;
  constructor(private jquery: JQueryHTTPClient) {
    super();
    this.client = new Rest.RestApplicationClient(jquery);
  }

  create(arg0: Rest.Subdelegation): Rest.RestResponse<Rest.Subdelegation> {
    return this.client.Subdelegation_create(arg0);
  }

  update(arg0: Rest.Subdelegation): Rest.RestResponse<Rest.Subdelegation> {
    return this.client.Subdelegation_update(arg0);
  }

  getPage(
    arg0: Rest.ListPaginationRequest,
    queryParams?: { includeDisabled?: boolean }
  ): Rest.RestResponse<Rest.Page<Rest.Subdelegation>> {
    return this.client.Subdelegation_getPage(arg0, queryParams);
  }

  getPageAndFilters(
    arg0: Rest.ListPaginationRequest
  ): Rest.RestResponse<Rest.ListPageAndFilters<Rest.Subdelegation>> {
    return this.client.Subdelegation_getPageAndFilters(arg0);
  }

  changeStatus(
    arg0: number[],
    queryParams?: { status?: boolean }
  ): Rest.RestResponse<void> {
    return this.client.Subdelegation_changeStatus(arg0, queryParams);
  }

  // @ts-ignore
  find(
    arg0: string,
    queryParams?: { id?: number }
  ): Rest.RestResponse<Rest.Subdelegation> {
    return this.client.Subdelegation_find(arg0, queryParams);
  }

  	getList(delegationId: number): Rest.RestResponse<Rest.Subdelegation[]> {
		return this.client.Subdelegation_getList(delegationId);
	}

	getListByClient(clientId: number): Rest.RestResponse<Rest.Subdelegation[]> {
		return this.client.Subdelegation_getListByClient(clientId);
	}

}
